/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mean, median, mode, standard deviation and more from a list of numbers.`)
};

const es_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media, mediana, moda, desviación estándar y más a partir de una lista de números.`)
};

const de_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittelwert, Median, Modus, Standardabweichung und mehr aus einer Zahlenliste.`)
};

const nl_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemiddelde, mediaan, modus, standaardafwijking en meer op basis van een lijst met getallen.`)
};

const fr_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyenne, médiane, mode, écart-type et plus à partir d'une liste de nombres.`)
};

const it_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media, mediana, moda, deviazione standard e altro da un elenco di numeri.`)
};

const pt_br2_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média, mediana, moda, desvio padrão e mais a partir de uma lista de números.`)
};

const pt_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média, mediana, moda, desvio-padrão e mais a partir de uma lista de números.`)
};

const ja_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値のリストから平均値、中央値、最頻値、標準偏差などを算出します。`)
};

const zh_st_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据一组数字计算平均数、中位数、众数、标准差等。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_tool_description", locale)
	if (locale === "en") return en_st_tool_description(inputs)
	if (locale === "es") return es_st_tool_description(inputs)
	if (locale === "de") return de_st_tool_description(inputs)
	if (locale === "nl") return nl_st_tool_description(inputs)
	if (locale === "fr") return fr_st_tool_description(inputs)
	if (locale === "it") return it_st_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_st_tool_description(inputs)
	if (locale === "pt") return pt_st_tool_description(inputs)
	if (locale === "ja") return ja_st_tool_description(inputs)
	return zh_st_tool_description(inputs)
};